import { z } from 'zod';

export const NoteTypeEnum = z.enum(['Order', 'Job', 'Item']);
export const NoteFacingTypeSchema = z.enum([
  'Customer',
  'Technician',
  'Order',
  'Job',
  'Auto Integrate',
]);

export const CreateNoteFeSchema = z.object({
  noteType: NoteTypeEnum,
  jobId: z.uuid().optional(),
  orderId: z.uuid(),
  noteContent: z.string(),
  facingType: NoteFacingTypeSchema,
  visibleToCustomer: z.boolean().optional(),
  isAiFleet: z.boolean().optional(),
  partId: z.uuid().optional(),
  addedBy: z.string().optional(),
});

export const UpdateNoteSchema = CreateNoteFeSchema.extend({
  noteId: z.uuid(),
});

export const RemoveNoteFeSchema = z.object({
  noteId: z.uuid(),
  orderId: z.uuid(),
  jobId: z.uuid().nullish(),
  partId: z.uuid().nullish(),
  noteType: NoteTypeEnum,
});

export const NoteSchema = z.object({
  noteSource: z.enum(['job', 'techApp']).nullish(),
  noteId: z.uuid(),
  isAiFleet: z.boolean().optional(),
  noteType: NoteTypeEnum,
  noteContent: z.string(),
  jobId: z.uuid().optional(),
  partId: z.uuid().optional(),
  jobRef: z.string().optional(),
  facingType: NoteFacingTypeSchema,
  dateAdded: z.coerce.date<Date>().optional(),
  addedBy: z.string().optional(),
  images: z.array(z.string()).optional(),
  imageUrl: z.string().optional(),
  item: z.string().optional(),
});

export const PartNoteSchema = NoteSchema.omit({
  noteId: true,
  noteSource: true,
  jobRef: true,
  dateAdded: true,
  noteType: true,
}).extend({
  id: z.uuid(),
  createdAt: z.coerce.date<Date>(),
  jobId: z.uuid().optional(),
  partId: z.uuid(),
});

export type CreateNoteFeModel = z.infer<typeof CreateNoteFeSchema>;
export type UpdateNoteModel = z.infer<typeof UpdateNoteSchema>;
export type RemoveNoteFeModel = z.infer<typeof RemoveNoteFeSchema>;
export type NoteModel = z.infer<typeof NoteSchema>;
export type NoteType = z.infer<typeof NoteTypeEnum>;
export type NoteFacingType = z.infer<typeof NoteFacingTypeSchema>;
